import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class CoachProfileViewsIndicator extends Component {

  render() {
    const { remainingCoachProfileViews } = this.props;
    
    let remainingProfileViewsMessage;
    let svgIcon;

    if (remainingCoachProfileViews > 1) {
      remainingProfileViewsMessage = `You have ${remainingCoachProfileViews} Profile Views left in your Free Trial.`;
      svgIcon = "#clock"
    } else if (remainingCoachProfileViews === 1) {
      remainingProfileViewsMessage = "You have 1 Profile View left in your Free Trial.";
      svgIcon = "#clock"
    } else {
      remainingProfileViewsMessage = "You have 0 Profile Views left in your Free Trial.";
      svgIcon = "#lock"
    }

    return (
      <div className="profile-views-left-message">
        <svg className=""><use xlinkHref={svgIcon} /></svg>
        <span>{remainingProfileViewsMessage}</span>
        <Link
          to='/settings/payment-info/subscribe'
          className="upgrade-button"
          title="Upgrade Now">
          Upgrade Now
        </Link>
      </div>
    );
  }
}

export default CoachProfileViewsIndicator


// WEBPACK FOOTER //
// ./src/components/Global/CoachProfileViewsIndicator.js